// extracted by mini-css-extract-plugin
export default {"title":"styles_title__39sWn","accent":"styles_accent__YxtcG","disclaimer":"styles_disclaimer__lhnj7","button":"styles_button__c1BFC"};